import React from "react";
import {Award} from "lucide-react";

// ===== Constants=====
const DEFAULT_TITLE = "Recognition Message"; // Default heading
const FROM_LABEL = "From"; // Label for sender
const TO_LABEL = "To"; // Label for recipient
interface RecognitionMessageProps {
    title?: string;
    message: string;
    from: string;
    to: string;
}

const RecognitionMessage: React.FC<RecognitionMessageProps> = ({
                                                                   title = DEFAULT_TITLE,
                                                                   message,
                                                                   from,
                                                                   to,
                                                               }) => {
    return (
        <div
            className="w-full relative rounded-3xl bg-blue-900/40 backdrop-blur-sm border border-blue-700/50 px-6 pt-3 pb-6 shadow-2xl mt-0 text-white flex flex-col lg:min-h-0 lg:overflow-hidden">

            {/* --- Header (title with Award icon) --- */}
            <div className="flex justify-center items-start mb-4 shrink-0">
                <span
                    className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-fuchsia-500 px-3 py-1 rounded-full text-sm font-semibold">
                    <Award className="w-5 h-5"/>
                    {title}
                </span>
            </div>

            {/* --- Message Body --- */}
            <div
                className="flex-1 lg:min-h-0 rounded-2xl bg-gradient-to-r from-purple-900/60 to-pink-900/60 px-4 py-4 md:px-10 md:py-6 flex items-center justify-center text-center lg:overflow-auto">
                <p className="text-base md:text-lg leading-relaxed break-words">
                    {message}
                </p>
            </div>

            <div className="mt-3 md:mt-4 shrink-0">
                <label className="block text-gray-300 font-semibold mb-1">{FROM_LABEL}</label>
                <div className="bg-blue-900 border border-blue-900 rounded-lg px-4 py-2 text-white">
                    {from}
                </div>
            </div>

            <div className="mt-3 md:mt-4 shrink-0">
                <label className="block text-gray-300 font-semibold mb-1">{TO_LABEL}</label>
                <div className="bg-blue-900  border-blue-900 rounded-lg px-4 py-2 text-white">
                    {to}
                </div>
            </div>
        </div>
    );
};

export default RecognitionMessage;
